var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#9B9B9B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.9,
    d: "M26.557 3.38c.613 0 1.11.497 1.11 1.11v2.8h0c-1.455 0-2.634 1.168-2.634 2.608 0 1.44 1.18 2.608 2.634 2.608v2.8a1.11 1.11 0 01-1.11 1.11H5.073a1.11 1.11 0 01-1.11-1.11v-2.8h0c1.455 0 2.634-1.168 2.634-2.608 0-1.44-1.18-2.607-2.634-2.607V4.49c0-.613.497-1.11 1.11-1.11h21.484z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M11 7.78h6.095M11 12.18h9.639"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3.33,
    d: "M1 19.701L30.325-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9B9B9B",
    strokeWidth: 1.9,
    d: "M3.037 19.701L28.593 1.383"
  })))));
}
export default SvgCancelled;